// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___2_e38","message":"styles__message___1wn_a"};